import { sp } from "@pnp/sp";

import getCurrentPageData from "./currentpage";
import { webAbsoluteUrl, cleanPrice, getWines, getSlots } from "./utils";
import { configuration } from "./config";

const fakeGetExperiences = () =>
  new Promise(resolve =>
    setTimeout(() => {
      resolve([
        {
          id: 1,
          title: "Wine & Food Experience",
          description:
            "Visita guidata alla cantina e ala bottaia, pranzo-cena degustazione di 3 portate con 4 vini in abbinamento, presso il Relais “Villa Grazianella”, parte della tenuta.",
          duration: "120''",
          glasses: "5 calici",
          price: 45,
          wines: [
            "Nobile di Montepulciano Antica Chiusina",
            "Nobile di Montepulciano Riserva",
            "Nobile di Montepulciano",
            "Rosso di Montepulciano",
            "Manero Bianco"
          ],
          morningSlotStart: [9, 0],
          morningSlotEnd: [11, 15],
          afternoonSlotStart: [13, 0],
          afternoonSlotEnd: [21, 30],
          type: "wine"
        },
        {
          id: 2,
          title: "I vini di Monterufoli",
          description:
            "Visita alla cantina degustazione guidata di tutti i vini della tenuta in abbinamento a salumi e formaggi di produttori locali.",
          duration: "90''",
          glasses: "6 calici",
          price: 90,
          wines: ["Pian di Seta", "Vermentino di toscana", "Poggio Miniera"],
          morningSlotStart: [9, 0],
          morningSlotEnd: [11, 15],
          afternoonSlotStart: [13, 0],
          afternoonSlotEnd: [21, 30],
          type: "wine"
        },
        {
          id: 3,
          title: "Cavalcata nel podere",
          description:
            "Esperienza di una cavalcata nei territori della riserva di Monterufoli.",
          duration: "120''",
          price: 80,
          morningSlotStart: [9, 0],
          morningSlotEnd: [11, 15],
          afternoonSlotStart: [13, 0],
          afternoonSlotEnd: [21, 30],
          type: "ride"
        }
      ]);
    }, 500)
  );

export const remoteGetExperiences = () =>
  getCurrentPageData().then(res =>
    res.Tenuta
      ? sp
          .search({
            Querytext: String.format(
              configuration.experiences.query,
              res.Tenuta.Label,
              webAbsoluteUrl
            ),
            RowLimit: 100,
            EnableInterleaving: true,
            SelectProperties: configuration.experiences.properties,
            TrimDuplicates: false
          })
          .then(r =>
            r.PrimarySearchResults.map(exp => ({
              id: exp.UniqueId,
              title: exp.Title,
              description: exp.DescrizioneBreveOWSTEXT,
              duration: exp.DurataOWSTEXT
                ? `${parseInt(exp.DurataOWSTEXT)}'`
                : "",
              glasses: exp.CaliciOWSTEXT,
              price: cleanPrice(exp.PrezzoOWSCURR) || 0,
              wines: getWines(exp.RefinableString08),
              morningSlotStart: getSlots(exp.InizioMattinaOWSCHCS) || [9, 0],
              morningSlotEnd: getSlots(exp.FineMattinaOWSCHCS) || [12, 0],
              afternoonSlotStart: getSlots(exp.InizioPomeriggioOWSCHCS) || [
                14,
                0
              ],
              afternoonSlotEnd: getSlots(exp.FinePomeriggioOWSCHCS) || [18, 0],
              type: exp.owstaxIdEsperienza
                .split(";")
                .filter(l => l.indexOf("L0|") === 0)[0]
                .split("|")[2]
            }))
          )
      : null
  );

export const getExperiences = configuration.fakeData
  ? fakeGetExperiences
  : remoteGetExperiences;
